import { FeedbackSummaryThumbDownButton } from '@modules/feed/components/SearchSummaryHeader/FeedbackSummaryThumbDownButton';
import { SearchActionType } from '@modules/feed/store/searchActionType';
import { useSearchStore } from '@modules/feed/store/searchStore';
import { AssistanceResponseThumbUpButton } from '@modules/oracle/components/AssistanceResponseThumbUpButton';
import { useFlagFeedbackSummary } from '@modules/oracle/hooks';
import { Box, Collapse } from '@mui/material';
import { useToggle } from 'react-use';

interface ExecutiveSummaryUserFeedbackCTAsProps {
  responseID: string;
}

export function ExecutiveSummaryUserFeedbackCTAs({
  responseID,
}: ExecutiveSummaryUserFeedbackCTAsProps) {
  const dispatch = useSearchStore(({ dispatch }) => dispatch);
  const likeSet = useSearchStore(({ visual }) => visual.likeSet);
  const isLiked = likeSet.has(responseID);
  const dislikeSet = useSearchStore(({ visual }) => visual.dislikeSet);
  const isDisliked = dislikeSet.has(responseID);
  const [flagFeedbackSummary] = useFlagFeedbackSummary();
  const [shouldPlayThumbUpAnimation, toggleShouldPlayThumbUpAnimation] =
    useToggle(false);

  const onThumbUpButtonClick = async () => {
    toggleShouldPlayThumbUpAnimation();

    await flagFeedbackSummary({
      isResponseGood: true,
      responseID,
    });

    toggleShouldPlayThumbUpAnimation();

    dispatch({
      type: SearchActionType.SET_VISUAL,
      payload: {
        likeSet: new Set([...likeSet, responseID]),
      },
    });
  };

  const thumbUpButton = isDisliked ? null : (
    <AssistanceResponseThumbUpButton
      responseID={responseID}
      onClick={onThumbUpButtonClick}
      disabled={isLiked}
      sx={{ color: 'text.secondary' }}
      shouldShowSpark={shouldPlayThumbUpAnimation}
    />
  );

  const thumbDownButton = isLiked ? null : (
    <Box>
      <Collapse in={!shouldPlayThumbUpAnimation} orientation="horizontal">
        <FeedbackSummaryThumbDownButton responseID={responseID} />
      </Collapse>
    </Box>
  );

  return (
    <>
      {thumbUpButton}
      {thumbDownButton}
    </>
  );
}
